import { apiClient } from "./apiClient";

export async function registrationRequest(
  name: string,
  email: string
): Promise<{ success: boolean }> {
  const body = { name, email };
  const { data } = await apiClient.post<{ success: boolean }>("/registration/request", body);
  return data;
}